import { Button, Select } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { Text, XStack } from "tamagui";

import { userStatuses } from "../options";
import { useUsersTableFilter } from "./context";

const USERS_FILTER = {
  name: "status" as const,
  title: "Статус",
  options: userStatuses,
};

type OptionsType = (typeof USERS_FILTER.options)[number]["value"];

export const UsersStatusSelect = () => {
  const { t } = useTranslation("filters");
  const { filter, dispatch } = useUsersTableFilter();

  return (
    <XStack alignItems="center" gap={"$1"}>
      <Text
        color={"$gray-primary-900"}
        fontFamily={"$subtitle"}
        fontWeight={"$5"}
        fontSize={"$2"}
        lineHeight={"$2"}
      >
        {t("user-status-filter.label")}
      </Text>

      <Select
        trigger={(Value) => (
          <Button width={"100%"} variant="gray" size={"sm"} rounded="lg">
            <XStack gap={"$1"} alignItems="center">
              <Value
                fontFamily={"$subtitle"}
                fontWeight={"$5"}
                fontSize={"$2"}
                lineHeight={"$2"}
                color={"$gray-primary-900"}
                placeholder={USERS_FILTER.title}
              />
            </XStack>
          </Button>
        )}
        value={filter.status ?? USERS_FILTER.options[0].value}
        onValueChange={(val) => {
          dispatch({
            type: "SET_FILTER",
            filterName: USERS_FILTER.name,
            value: val as OptionsType,
          });
        }}
        label={USERS_FILTER.title}
        items={
          USERS_FILTER.options as unknown as { name: string; value: string }[]
        }
      />
    </XStack>
  );
};
